import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getInvoiceDetails, getMyInvoiceDetails 
} from "../../../../redux/invoice/invoiceState";
import { useForm } from 'antd/lib/form/Form';
import { NumberFormatter } from "../../../../utils/index";
import CrudButtons from "components/button/crudbuttons";
import { DATE_FORMAT } from "variables/constants";

const InvoiceForm = ({getRecord, recordData, requesting, errors, onCancel, submitLabel, getMyInvoice, invoiceNum, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId ?? 0);
	}, [getRecord, recordId]);

	useEffect(() => {
		if(invoiceNum){
        	getMyInvoice({invoiceNum});
		}
	}, [getMyInvoice, invoiceNum]);
	
	useEffect(() => {
		if(recordData){

			const { inv_issue_date, inv_due_date, created_at, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	            inv_issue_date: inv_issue_date ? dayjs(inv_issue_date, DATE_FORMAT) : null,
				created_at: created_at ? dayjs(created_at, DATE_FORMAT) : null,
			    inv_due_date: inv_due_date ? dayjs(inv_due_date, DATE_FORMAT) : null,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
	        >   
        		<div className="grid grid-cols-1 md:grid-cols-5 gap-2"> 
					<FormItem 
		            	name="inv_status_id"
		                label="Invoice #"
		            >
		                <label className="ps-3 dark:text-white">{recordData?.inv_number}</label>
	            	</FormItem>
					
					<FormItem 
		            	name="inv_type_id"
		                label="Type"
		            >
		                <label className="ps-3 dark:text-white">{recordData?.inv_type_name}</label>
	            	</FormItem>
					{/* <FormItem 
		            	name="inv_forex_id"
		                label="Forex Date"
		            >
						<label className="ps-3 dark:text-white">{recordData?.forex_name}</label>
	            	</FormItem> */}
					{/* <FormItem 
						name="inv_forex_usd"
						label="PHP to USD"
					>
						<label className="ps-3 dark:text-white">{NumberFormatter(recordData?.inv_forex_usd, 4)}</label>
						
					</FormItem> */}
					<FormItem 
						name="inv_forex_aud"
						label="PHP to AUD"
					>
						<label className="ps-3 dark:text-white">{NumberFormatter(recordData?.inv_forex_aud, 4)}</label>
					</FormItem>
					{/* <FormItem 
						label="Issued Date"
						name="inv_issue_date"
					>
						<label className="text-base label-value dark:text-white">
							{recordData?.inv_issue_date}
						</label>
					</FormItem> */}
					<FormItem 
						label="Due Date"
						name="inv_due_date"
					>
						<label className="text-base label-value dark:text-white">
							{recordData?.inv_due_date}
						</label>
					</FormItem>
	            	{/* <FormItem 
		            	name="inv_status_id"
		                label="Status"
		            >
		                <label className="ps-3 dark:text-white">{recordData?.inv_status_name}</label>
	            	</FormItem> */}
	 			</div>		
				<CrudButtons baseRoute="/console/my-invoices" mode={mode} recordId={recordId} withEdit={false} /> 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.invoice.invoiceDetails?.data,
  	requesting: state.invoice.invoiceDetails?.requesting,
  	errors: state.invoice.invoiceDetails?.errors,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getInvoiceDetails(id)),
	getMyInvoice: (data) => dispatch(getMyInvoiceDetails(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
